export class AbstractToggleDirective {
    constructor() {
        this.state = false;
    }
    toggle(value) {
        this.state = value;
        return this;
    }
    getMinimumCspVersion() {
        return 1;
    }
    serialize() {
        if (!this.state) {
            return '';
        }
        return `${this.getDirectiveName()};`;
    }
}
